import { ApplicationRef, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ImportServiceV2 } from 'src/app/services/imports/import.service-v2';
import { ImportServiceV3 } from 'src/app/services/imports/import.service-v3';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { scheduleAppRefresh } from 'src/app/shared/utils/refresh-view';
import { ItemResumoImportacao } from 'src/models/interfaces/importação/resumo-importacao-interface';

@Component({
  selector: 'spe-resumo-itens-importados',
  templateUrl: './resumo-itens-importados.component.html',
  styleUrls: ['./resumo-itens-importados.component.scss'],
  standalone: false
})
export class ResumoItensImportadosComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  public companyName = '';
  public companyCNPJ = '';
  public date = '';
  public dataSource: ItemResumoImportacao[] = [];
  public diff = 0;
  public total = 0;
  public totalDiff = 0;
  public sigla = localStorage.getItem('sigla');

  constructor(
    public readonly importService: ImportServiceV2,
    private readonly importServiceV3: ImportServiceV3,
    private readonly route: ActivatedRoute,
    private themeService: ThemeService,
    private readonly cdr: ChangeDetectorRef,
    private readonly appRef: ApplicationRef,
    private readonly ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.companyName = localStorage.getItem('nomeRazaoSocial') ?? '';
    this.companyCNPJ = localStorage.getItem('cnpj') ?? '';

    const isNewUpload = this.route.snapshot.queryParamMap.get('isNewUpload');
    const idImportacao = this.route.snapshot.queryParamMap.get('idImportacao');

    if (isNewUpload === 'true' && idImportacao) {
      const subscription = this.importServiceV3.getDetalhamento(idImportacao).subscribe({
        next: (data) => {
          const detalhamento = data?.detalhamento;
          this.applyResumo({
            dataDaImportacao: detalhamento?.dataDaImportacao ?? '',
            diferenca: detalhamento?.diferenca ?? 0,
            valorTotalIPB: detalhamento?.valorTotalIPB ?? 0,
            valorTotalVTO: detalhamento?.valorTotalVTO ?? 0,
            itens: (detalhamento?.itens as ItemResumoImportacao[]) ?? []
          });
        },
        error: () => {
          this.refreshView();
        }
      });
      this.subscriptions.push(subscription);
    } else {
      const subscription = this.importService.getImportedItems().subscribe({
        next: (data) => {
          this.applyResumo({
            dataDaImportacao: data?.dataDaImportacao ?? '',
            diferenca: data?.diferenca ?? 0,
            valorTotalIPB: data?.valorTotalIPB ?? 0,
            valorTotalVTO: data?.valorTotalVTO ?? 0,
            itens: data?.itens ?? []
          });
        },
        error: () => {
          this.refreshView();
        }
      });
      this.subscriptions.push(subscription);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  private applyResumo(data: {
    dataDaImportacao: string;
    diferenca: number;
    valorTotalIPB: number;
    valorTotalVTO: number;
    itens: ItemResumoImportacao[];
  }): void {
    this.date = data.dataDaImportacao;
    this.diff = data.diferenca;
    this.total = data.valorTotalIPB;
    this.totalDiff = data.valorTotalVTO;
    this.dataSource = data.itens;
    this.refreshView();
  }

  private refreshView(): void {
    this.cdr.detectChanges();
    scheduleAppRefresh(this.appRef, this.ngZone);
  }

  public hasDiferencaTarifa = (flag: string): boolean => {
    if (flag == 'N') {
      return false;
    } else {
      return true;
    }
  };

  public downloadExcel(): void {
    const fileName = `Resumo_Itens_Importados_${this.companyName}_${this.date}.xlsx`;
    this.importService.getExcelImportedItems(fileName).subscribe();
  }

  public readonly showValue = (element: number, signal = false): string => {
    const amount = Number(element ?? 0);
    if (Number.isNaN(amount)) {
      return '0,00';
    }
    const formatted = amount.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    if (signal && amount !== 0) {
      return amount > 0 ? `-${formatted}` : formatted;
    }
    return formatted;
  };
}
